import VadImage from "vadimages-nextjs-image-optimizer";
import React from "react";
import { LogoCarouselItem } from "@/app/parts/home-page/LogoCarousel";
import css from './image-carousel.module.scss';

export interface ImageCarouselProps {
    images: LogoCarouselItem[];
}

export const ImageCarousel = ({ images }: ImageCarouselProps) => {
    const doubledImages = [...images, ...images];
    const width = doubledImages.map((item: LogoCarouselItem) => item.width).reduce((a, b) => a + b, 0) + (40 * doubledImages.length);

    return (
      <div
          style={{ width: `${width}px` }}
          className={`absolute z-10 w-full md:h-full overflow-hidden flex items-center gap-6 ${css['carousel-items']}`}
      >
          {
              doubledImages.map((frame, index) => (
                  <VadImage
                      key={index}
                      src={frame.src}
                      alt='lifes irritations frame'
                      width={frame.width}
                      height={frame.height}
                  />
              ))
          }
      </div>
    );
};
